import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "p-d-flex p-ai-center" }
const _hoisted_3 = { class: "p-d-flex p-ai-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user" }, null, -1)
const _hoisted_5 = { class: "p-field" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = { for: "newusername" }
const _hoisted_8 = { class: "p-field" }
const _hoisted_9 = { class: "p-float-label" }
const _hoisted_10 = { for: "surname" }
const _hoisted_11 = { class: "p-field" }
const _hoisted_12 = { class: "p-float-label" }
const _hoisted_13 = { for: "email-off" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-key" }, null, -1)
const _hoisted_15 = { class: "p-field" }
const _hoisted_16 = { class: "p-float-label" }
const _hoisted_17 = { for: "password" }
const _hoisted_18 = { class: "p-field" }
const _hoisted_19 = { class: "p-float-label" }
const _hoisted_20 = { for: "confirm-password" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _component_Divider = _resolveComponent("Divider")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createVNode(_component_Button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$router.back();}),
          icon: "pi pi-arrow-left",
          class: "p-mb-0"
        }, null, 512), [
          [
            _directive_tooltip,
            _ctx.$t('back'),
            void 0,
            { bottom: true }
          ]
        ]),
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('profile.title')), 1)
      ]),
      _createElementVNode("div", null, [
        _withDirectives(_createVNode(_component_Button, {
          icon: "pi pi-save",
          class: "p-mr-1",
          onClick: _ctx.onSave,
          disabled: !_ctx.isSaveEnabled
        }, null, 8, ["onClick", "disabled"]), [
          [
            _directive_tooltip,
            _ctx.$t('save'),
            void 0,
            { bottom: true }
          ]
        ])
      ])
    ]),
    (_ctx.currentUser)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          autocomplete: "nope",
          onSubmit: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createVNode(_component_Fieldset, { class: "p-fluid" }, {
            legend: _withCtx(() => [
              _hoisted_4
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, [
                  _createVNode(_component_InputText, {
                    autocomplete: "off",
                    type: "text",
                    modelValue: _ctx.currentUser.name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentUser.name = $event)),
                    disabled: !_ctx.isFieldEnabled
                  }, null, 8, ["modelValue", "disabled"]),
                  _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('profile.first_name')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, [
                  _createVNode(_component_InputText, {
                    autocomplete: "off",
                    id: "surname",
                    type: "text",
                    modelValue: _ctx.currentUser.surname,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.currentUser.surname = $event)),
                    disabled: !_ctx.isFieldEnabled
                  }, null, 8, ["modelValue", "disabled"]),
                  _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('profile.last_name')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, [
                  _createVNode(_component_InputText, {
                    autocomplete: "nope",
                    id: "email-off",
                    type: "email",
                    modelValue: _ctx.currentUser.email,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.currentUser.email = $event)),
                    disabled: !_ctx.isFieldEnabled
                  }, null, 8, ["modelValue", "disabled"]),
                  _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('profile.email')), 1)
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Divider),
          _createVNode(_component_Fieldset, { class: "p-fluid" }, {
            legend: _withCtx(() => [
              _hoisted_14
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("span", _hoisted_16, [
                  _createVNode(_component_InputText, {
                    autocomplete: "new-password",
                    id: "password",
                    type: "password",
                    modelValue: _ctx.currentUser.password,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.currentUser.password = $event)),
                    modelModifiers: { trim: true }
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('profile.password')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("span", _hoisted_19, [
                  _createVNode(_component_InputText, {
                    autocomplete: "new-password",
                    id: "confirm-password",
                    type: "password",
                    modelValue: _ctx.confirmPassword,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.confirmPassword = $event)),
                    modelModifiers: { trim: true }
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('profile.confirm_password')), 1)
                ])
              ])
            ]),
            _: 1
          })
        ], 32))
      : _createCommentVNode("", true)
  ]))
}